import { DEFAULT_PROPS, EnvConfig, Props } from '@/models/app-internal/env.model';
import { PAYMENTS_SECTIONS_ROUTES_META_TITLES } from '@/models/app-internal/meta-titles.model';
import router from '@/router/router';
import { defineStore } from 'pinia';
import { usePermissionsStore } from './permissions.store';

export const useEnvStore = defineStore({
  id: 'env',
  state: (): EnvConfig => ({
    MOCKS_ENABLED: '0',
    BACKOFFICE_API_URL: DEFAULT_PROPS().apiUrl,
    MULTIBRAND_API_URL: DEFAULT_PROPS().multibrandApiUrl,
    MULTIBRAND_API_HOST: DEFAULT_PROPS().multibrandApiHost,
    WL_SLUG: DEFAULT_PROPS().wlSlug,
    CURRENT_PARTENT_ROUTE_NAME: DEFAULT_PROPS().currentParentRouteName,
    WHITELABEL_ID: DEFAULT_PROPS().whitelabelId,
  }),
  actions: {
    setEnv(props: Props): void {
      this.setWlSlug(props.wlSlug || DEFAULT_PROPS().wlSlug);
      this.BACKOFFICE_API_URL = props.apiUrl || `${DEFAULT_PROPS().apiUrl}/${this.WL_SLUG}`;
      this.MULTIBRAND_API_URL = props.multibrandApiUrl;
      this.MULTIBRAND_API_HOST = props.multibrandApiUrl ? new URL(props.multibrandApiUrl).origin : '';
      this.setServicePermissions(props.servicePermissions);
      this.setCurrentParentRouteName(props.currentParentRouteName);
      this.setWhitelabelId(props.whitelabelId);
    },
    setWlSlug(wlSlug: string): void {
      this.WL_SLUG = wlSlug;
      this.updateBackofficeApiUrl();
    },
    updateBackofficeApiUrl(): void {
      this.BACKOFFICE_API_URL = `${DEFAULT_PROPS().apiUrl}/${this.WL_SLUG}`;
    },
    setServicePermissions(input: string): void {
      const { setPermissions } = usePermissionsStore();
      setPermissions(JSON.parse(input));
    },
    async setCurrentParentRouteName(currentParentRouteName: string): Promise<void> {
      // Этот метод устанавливает текущий роут в микрофронте
      // при его изменении в родительском микрофронте
      this.CURRENT_PARTENT_ROUTE_NAME = currentParentRouteName;

      await router.isReady();

      router.push({ name: currentParentRouteName }).finally(() => {
        this.setMetaTitle(PAYMENTS_SECTIONS_ROUTES_META_TITLES[currentParentRouteName] ?? 'Backoffice');
      });
    },
    setMetaTitle(title: string): void {
      const titleEl = document.querySelector('head title');

      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      titleEl!.textContent = (title);
    },
    setWhitelabelId(whitelabelId: string): void {
      this.WHITELABEL_ID = whitelabelId;
    },
  },
});
